import { render, staticRenderFns } from "./optionDetail.vue?vue&type=template&id=f5c0be1e&scoped=true&"
import script from "./optionDetail.vue?vue&type=script&lang=js&"
export * from "./optionDetail.vue?vue&type=script&lang=js&"
import style0 from "./optionDetail.vue?vue&type=style&index=0&id=f5c0be1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c0be1e",
  null
  
)

export default component.exports